export const brandThemeStyle = (theme = {}) => {
  const style = {};
  if (theme.heading_font) {
    style["--brand-heading"] = theme.heading_font;
    style["--brand-heading-weight"] = 300;
    style["--brand-heading-tracking"] = theme.heading_uppercase ? "0.04em" : "-0.01em";
  }
  if (theme.body_font) style["--brand-body"] = theme.body_font;
  if (theme.heading_uppercase) style["--brand-transform"] = "uppercase";
  if (theme.ink) style["--brand-ink"] = theme.ink;
  if (theme.accent) style["--brand-accent"] = theme.accent;
  if (theme.surface) style["--brand-surface"] = theme.surface;
  return style;
};

export const hasTheme = (theme = {}) => Object.values(theme).some(Boolean);

export default function BrandTheme({ theme, children, ...rest }) {
  return (
    <div className="brand-themed" style={brandThemeStyle(theme)} data-brand-themed={hasTheme(theme) ? "custom" : "default"} {...rest}>
      {children}
    </div>
  );
}
